export default function TripCheckoutModel() {
    Object.assign(this, {
        selectedOption: null,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/checkout/trip-checkout-model.js